<template>
  <el-row
    type="flex"
    justify="center"
    align="top"
    class="min-vh-100 bg-brand"
  >
    <el-col
      :xs="23"
      :sm="12"
      :md="11"
      :lg="9"
      :xl="6"
      class="text-center"
    >
      <OpenFreightLogo
        class="pt-8 pb-5 w-75"
        style="fill: white;"
      />

      <RouterView class="p-3 mb-2" />
    </el-col>
  </el-row>
</template>

<script>
import OpenFreightLogo from '@/assets/images/openfreight.svg'
import Session from '@/plugins/session'

export default {
  components: {
    OpenFreightLogo
  },
  async beforeRouteEnter (to, from, next) {
    // Don't do session check for reset password and signin routes
    if (to.name === 'authentication-resetpassword' || to.name === 'authentication-signin') {
      return next()
    }

    let redirect

    if (await Session.active) {
      redirect = {
        replace: true
      }

      if (typeof to.query.redirect !== 'undefined' && from.name !== 'signin') {
        redirect.path = to.query.redirect
      } else {
        redirect.name = 'application'
      }
    }

    next(redirect)
  }
}
</script>
